import { IOpData, IReferenceType, IOpChangeState } from '../util/interfaces'
import { DataType } from '../../helpers/common-helper'
import { Utils } from '../util/utils'
import { OpChangeState, Enums } from '../common/enums'

import { OpDataType } from '../core/op-data-type'

export class OpReportData implements IOpData {
    //Properties
    public idReportData: number
    public idReport: number
    public idDataType: number
    public indexNbr: number
    public value: any
    //Properties end

    //NavigationProperties
    public dataType: OpDataType
    //NavigationProperties end

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IOpData implementation
    public get idData() { return this.idReportData }
    //get idDataType() { return this.idDataType }
    public get indexNBR() { return this.indexNbr }
    //get value() { return this.value }
    //IOpData implementation end

    public fromJSON(opObj: any, compress: boolean = false) {
        if (opObj) {
            this.idReportData = opObj.ID_REPORT_DATA
            this.idReport = opObj.ID_REPORT
            this.idDataType = opObj.ID_DATA_TYPE
            this.indexNbr = opObj.INDEX_NBR
            this.value = opObj.VALUE

            this.dataType = opObj._DataType
        } else {
            this.idReportData = 0
            this.opState = OpChangeState.New
        }
    }

    public toJSON(compress: boolean = false): any {
        return {
            ID_REPORT_DATA: this.idReportData,
            ID_REPORT: this.idReport,
            ID_DATA_TYPE: this.idDataType,
            INDEX_NBR: this.indexNbr,
            VALUE: this.value
        }
    }

    public static fromIOpData(data: IOpData): OpReportData {
        const newData: OpReportData = new OpReportData(null)

        newData.idReportData = data.idData,
        newData.idDataType = data.idDataType
        newData.indexNbr = data.indexNBR
        newData.value = data.value
        newData.opState = data.opState

        return newData
    }
}